import {
  createFilteringStage,
  createSortStage,
  createPagingStages,
  CustomPipelineFactory,
  createCountPipeline,
} from '@/providers/dataProvider';
import { createDefaultTherapistsFilter } from '../therapists/therapistMatchers';
import { aggregate } from '@/providers/backendClient';

export const therapistHomeworkCustomFetcher: CustomPipelineFactory =
  async ({ sort, filter: filterValues, page, perPage }) => {
    const combinedFilter =
      await createDefaultTherapistsFilter(filterValues);

    const match = createFilteringStage(combinedFilter);

    const sortStage = createSortStage(sort);

    const pagingPipeline = createPagingStages(page, perPage);

    const resultsPipeline = [
      match,
      sortStage,
      ...pagingPipeline,
      dataCleaningStage,
      ...reportPipeline,
    ];

    const countPipeline = createCountPipeline([match]);

    const pipelines = {
      results: resultsPipeline,
      total: countPipeline,
    };

    const {
      results,
      total: [{ count = 0 } = {}],
    } = await aggregate('therapistHomework', pipelines, {
      allowDiskUse: true,
    });

    return { results, total: count };
  };

const dataCleaningStage = {
  $addFields: {
    narrative: {
      $binarySize: '$narrative',
    },
    transcript: {
      $binarySize: '$transcript',
    },
    followUpQuestion: {
      $binarySize: '$patientHomework',
    },
    patientHomework: {
      $binarySize: '$patientHomework',
    },
  },
};

const reportPipeline = [
  {
    $lookup: {
      from: 'hiddenAdminTherapists',
      localField: 'therapistId',
      foreignField: '_id',
      as: 'isFromHiddenTestTherapist',
    },
  },
  {
    $unwind: {
      path: '$isFromHiddenTestTherapist',
      includeArrayIndex: 'string',
      preserveNullAndEmptyArrays: true,
    },
  },
  {
    $addFields: {
      isFromHiddenTestTherapist: {
        $toBool: {
          $ifNull: ['$isFromHiddenTestTherapist', false],
        },
      },
    },
  },
  {
    $lookup: {
      from: 'therapists',
      localField: 'therapistId',
      foreignField: '_id',
      as: 'therapist',
    },
  },
  {
    $unwind: {
      path: '$therapist',
      preserveNullAndEmptyArrays: true,
    },
  },
  {
    $addFields: {
      therapistFirstName: '$therapist.firstName',
      therapistLastName: '$therapist.lastName',
      therapistTitle: '$therapist.title',
      therapistEmail: '$therapist.email',
    },
  },
  {
    $project: {
      therapist: 0,
    },
  },
];
